import {FormControl, FormHelperText, Input, InputLabel} from '@material-ui/core'
import InputMask from 'react-input-mask'
import React from 'react'

export default ({ field, form, label, mask, onBlur, helperText, ...props }) => {
  const error = form.errors[field.name]
  const touched = form.touched[field.name]
  const showError = touched && !!error

  return (
    <FormControl error={showError} fullWidth>
      <InputLabel htmlFor={field.name}>{label}</InputLabel>
      <InputMask
        disabled={form.isSubmitting}
        mask={mask}
        maskChar=""
        name={field.name}
        value={field.value}
        onChange={form.handleChange}
        onBlur={(event) => onBlur && onBlur(event, form)}
      >
        {(inputProps) => <Input {...inputProps} type="tel" />}
      </InputMask>
      <FormHelperText error={showError}>{showError ? error : helperText}</FormHelperText>
    </FormControl>
  )
};
